import { useEffect, useState } from 'react';

const useSystemDarkTheme = () => {
	const mediaQueryListEvent = window.matchMedia('(prefers-color-scheme: dark)');

	const [isDarkTheme, setIsDarkTheme] = useState(mediaQueryListEvent.matches);

	useEffect(() => {
		mediaQueryListEvent.onchange = () => setIsDarkTheme(mediaQueryListEvent.matches);

		return () => {
			mediaQueryListEvent.onchange = () => null;
		};
	}, []);

	return isDarkTheme;
};

export default useSystemDarkTheme;
